const specialKey = 'ωPayloadType';

export const isDetailsHasTypeEventInfo = (details: Record<any, any>) => Boolean(details && details[specialKey]);

export function spaDispatchEvent(name: string, details?: any, payloadTypeEvent?: string, win?: Window) {
	details = payloadTypeEvent ? { type: payloadTypeEvent, payload: details, [specialKey]: true } : details;

	(win || window).dispatchEvent(
		new CustomEvent(name, {
			detail: details,
		})
	);
}
